// tslint:disable
/**
 * Audit
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AuditQueryRequest } from '../models';
import { AuditQueryResponse } from '../models';
import { ProblemDetails } from '../models';
/**
 * LogApi - axios parameter creator
 * @export
 */
export const LogApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {AuditQueryRequest} [auditQueryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logPost(auditQueryRequest?: AuditQueryRequest, options: any = {}): RequestArgs {
      const localVarPath = `/log`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof auditQueryRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(auditQueryRequest !== undefined ? auditQueryRequest : {})
        : auditQueryRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LogApi - functional programming interface
 * @export
 */
export const LogApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {AuditQueryRequest} [auditQueryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logPost(
      auditQueryRequest?: AuditQueryRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditQueryResponse> {
      const localVarAxiosArgs = LogApiAxiosParamCreator(configuration).logPost(
        auditQueryRequest,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * LogApi - factory interface
 * @export
 */
export const LogApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {AuditQueryRequest} [auditQueryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logPost(
      auditQueryRequest?: AuditQueryRequest,
      options?: any
    ): AxiosPromise<AuditQueryResponse> {
      return LogApiFp(configuration).logPost(auditQueryRequest, options)(axios, basePath);
    },
  };
};

/**
 * LogApi - object-oriented interface
 * @export
 * @class LogApi
 * @extends {BaseAPI}
 */
export class LogApi extends BaseAPI {
  /**
   *
   * @param {AuditQueryRequest} [auditQueryRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LogApi
   */
  public logPost(auditQueryRequest?: AuditQueryRequest, options?: any) {
    return LogApiFp(this.configuration).logPost(auditQueryRequest, options)(
      this.axios,
      this.basePath
    );
  }
}
